export function isPastEvent(dateStr) {
  if (!dateStr) return false;
  return new Date(dateStr) < new Date(new Date().toDateString());
}

export default function PastEventStamp({ active, children, className = "" }) {
  if (!active) return children;
  return (
    <div className={`relative ${className}`}>
      <div className="grayscale-[0.45]">{children}</div>
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <div
          className="-rotate-6 border-4 border-red-600/90 text-red-600 rounded-xl px-3 py-2 sm:px-5 sm:py-3 bg-white/85 shadow-lg text-center"
          data-testid="past-event-stamp"
        >
          <p className="text-sm sm:text-lg font-black uppercase tracking-widest leading-tight">Événement passé</p>
          <p className="text-[10px] sm:text-xs font-semibold mt-0.5 leading-snug">
            Merci de votre mobilisation
            <br />
            Merci à nos bénévoles
          </p>
        </div>
      </div>
    </div>
  );
}
